<bl-modal-content #content
  [title]="'画面動作設定'"
>
  <div body>
    <div class="contents">
      <div class="setting-item setting-item--explanation">
        {{availableVehicleCustomer}}ランク設定で決めた色分けを反映するか選択してください。
      </div>
      <div class="setting-item">
        <div class="setting-item__label">
          <label>
            {{availableVehicleCustomerRankColor}}ランクによる色分け
          </label>
        </div>
        <div class="setting-item__input">
          <bl-radio-group
            #customerRankColor
            [(value)]="_screenActionSetting && _screenActionSetting.customerRankColorDiv"
            groupType="inline"
            [items]="_customerRankColorItems"
          ></bl-radio-group>
        </div>
      </div>
      <div class="setting-item setting-item--notice">
        ※画面動作設定はご利用のアカウントごとに保存されます。
      </div>
    </div>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/feature/customer-vehicle-search-screen-action-setting-modal/customer-vehicle-search-screen-action-setting-modal.component.html